export default __webpack_public_path__ + "static/media/Pearl of Heaven.12ad938a.jpg";